export default {"src":"/_next/static/media/wallet_connect_icon_black.2b862ba9.svg","height":20,"width":34,"blurWidth":0,"blurHeight":0};